import type { SVGProps } from "react";
const SvgCancelSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m12.5 7.5-5 5m5 0-5-5"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M2.083 10c0-3.732 0-5.598 1.16-6.757 1.16-1.16 3.025-1.16 6.757-1.16s5.598 0 6.757 1.16c1.16 1.16 1.16 3.025 1.16 6.757s0 5.598-1.16 6.757c-1.16 1.16-3.025 1.16-6.757 1.16s-5.598 0-6.757-1.16c-1.16-1.159-1.16-3.025-1.16-6.757Z"
    />
  </svg>
);
export default SvgCancelSquare;
